import { render, staticRenderFns } from "./ComplainDiscussion.vue?vue&type=template&id=e4f4c3bc&"
import script from "./ComplainDiscussion.vue?vue&type=script&lang=js&"
export * from "./ComplainDiscussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports